import { formatDate } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import * as localforage from "localforage";
import { forkJoin, Observable, Subject } from "rxjs";
import { HandleDataService } from "src/app/services/authentication/handle-data.service";
import { SkyaccessApp } from "src/app/services/skyaccessconfig/skyaccess-app.service";
import { environment } from "src/environments/environment"; 

@Injectable({
  providedIn: "root",
})
export class LoadDataService {
  private destroy$ = new Subject<boolean>();

  loadDoorDB_Instance: LocalForage;
  loadDashboardDB_Instance: LocalForage;
  loadSkyAccess_DB: LocalForage;

  hasLoadedDoorsFromAPI = false;
  hasLoadedDashboardFromAPI = false;
  hasAPIError = false;

  emitDone = new EventEmitter<any>();



  cachedDoors;
  cachedDashboard = {};
  cachedServices = [];
  cachedPersons;

 public static CACHE_KEYS_STR = {
    DOORS : "DOORS",
    SERVICES: "SERVICES",
    DASHBOARDS: "DASHBOARDS",
    HARDWARES_ILOCK: "HARDWARES_ILOCK",
    ACCESSPOINTS: "ACCESSPOINTS",
    SYSTEMSETTINGS: "SYSTEMSETTINGS",
    RFIDSETTINGS: "RFIDSETTINGS",
    HARDWARES_WR: "HARDWARES_WR",
    ACCESS_POINTS: "ACCESS_POINTS",
    ACCESS_POINT_GROUPS : "ACCESS_POINT_GROUPS",
    TIMETABLE: "TIMETABLE",
    WEEKLY_PROGRAM: "WEEKLY_PROGRAM",
    DOOR_PROGRAM: "DOOR_PROGRAM"
    
  };


  constructor(
    private http: HttpClient,
    private handleDataService: HandleDataService,
    private skyAccessService: SkyaccessApp, 
  ) {}

  initDoorCache() {

    this.hasLoadedDoorsFromAPI = true;
    this.hasLoadedDashboardFromAPI = true;
    this.emitDone.emit(true);
    return;

    
    this.hasLoadedDoorsFromAPI = false;
    this.hasLoadedDashboardFromAPI = false;
    this.hasAPIError = false;

    this.loadDoorDB_Instance = localforage.createInstance({
      name: "data_cache",
      storeName: "doors",
    });

    this.loadDashboardDB_Instance = localforage.createInstance({
      name: "data_cache",
      storeName: "dashboard",
    });

    this.loadSkyAccess_DB = localforage.createInstance({
      name: "data_cache",
      storeName: "skyAccess",
    });

    this.loadDoorDB_Instance.clear().then((val) => {});
    // this.loadDashboardDB_Instance.clear().then(val => {});
    ["default", "summary", "skyAccess"].forEach((key) => {
      this.loadDashboardDB_Instance.getItem(key).then((value) => {
        if (value != undefined) this.cachedDashboard[key] = value;
      });
    });
    this.loadSkyAccess_DB.getItem("skyList").then((skyAccessData) => {
      if (Array.isArray(skyAccessData)) {
        this.skyAccessService.setAllPages(skyAccessData);
      }
    });

    //TODO: Implement later - services
    // setTimeout(() => {
    //   this.accessService.getGridData().subscribe((res) => {
    //     if (res == undefined) return;
    //     while (this.cachedServices.length) this.cachedServices.pop();
    //     res.forEach((service) => this.cachedServices.push(service));
    //     // this.cachedServices = res;
    //   });
    // });

    if (!environment.production && localStorage.doors != undefined) {
      this.cachedDoors = JSON.parse(localStorage.doors);
      this.hasLoadedDoorsFromAPI = true;
      (this.cachedDoors);
      this.emitDone.emit(true);
      return;
    }

    setTimeout(() => {
      forkJoin([
        // this.handleDataService.getDoorData(),
        this.handleDataService.getDoorList(),
      ]).subscribe(
        (response: any) => {
          const doors = response[0] as any[];
          const doorList = response[1] as any[];
          this.cachedDoors = doors;
          const rand12 = (max) => Math.floor(Math.random() * (1 - 0 + 1)) + 0;
          this.cachedDoors.forEach((element, index: number) => {
            element.DoorList = doorList[index];
            element.DoorStatus = rand12(1) ? 1 : 7;
            element.ALARMON = element.locktable._DoorAlarm;
            element.Status1 = element.locktable._OnlineStatus;
            element.Status2 = element.locktable._DoorState >= 5 ? 1 : 0;
            element.Status3 = element.locktable._DoorState === 4 ? 1 : 0;
            element.Status4 = element.locktable._BatteryStatus;
          });
          // temp implementation dev environment
          if (!environment.production)
            localStorage.setItem("doors", JSON.stringify(doors));
          doors.forEach((door) => {
            this.loadDoorDB_Instance.setItem(door.DoorID.toString(), door);
          });
          this.hasLoadedDoorsFromAPI = true;
          this.emitDone.emit(true);
        },
        (err) => {
          this.hasAPIError = true;
          this.emitDone.emit(false);
        }
      );
    }, 2000);


    // this.handleDataService.getDashboardData().subscribe(response => {
    //   const dashboards = response as any[];
    //   this.loadDashboardDB_Instance.setItem('default', dashboards[0]);
    //   this.loadDashboardDB_Instance.setItem('summary', dashboards[1]);
    //   this.loadDashboardDB_Instance.setItem('skyaccess', dashboards[2]);
    //   this.hasLoadedDashboardFromAPI = true;
    //   this.emitDone.emit(true);
    // }, err => {
    //   this.hasAPIError = true;
    //   this.emitDone.emit(false);
    // });
  }

  initOnlyDBInstances() {
    this.loadDoorDB_Instance = localforage.createInstance({
      name: "data_cache",
      storeName: "doors",
    });
    this.loadDashboardDB_Instance = localforage.createInstance({
      name: "data_cache",
      storeName: "dashboard",
    });
  }

  async parseDBDoors() {
    if (this.cachedDoors) return this.cachedDoors;
    if (!this.loadDoorDB_Instance) this.initOnlyDBInstances();
    var start = performance.now();
    let doors = [];
    ((await this.loadDoorDB_Instance.keys()) as any).forEach(async (item) => {
      let doorItem = (await this.loadDoorDB_Instance.getItem(item)) as any;
      doors.push(doorItem);
    });
    var end = performance.now();
    (`Execution time: ${end - start} ms`);
    (doors);
    this.cachedDoors = doors;
    return doors;
  }

  async setDashboard(key, dataset) {
    this.loadDashboardDB_Instance.setItem(key, dataset).then((value) => {
      this.cachedDashboard[key] = dataset;
    });
  }

  async getDashboard(key) {
    if (this.cachedDashboard[key] != undefined)
      return Promise.resolve(this.cachedDashboard[key]);
    return this.loadDashboardDB_Instance.getItem(key);
  }

  public static GetLastUpdateDate(cache : CACHE_KEYS) : any {
    try { 
      var Tmp = localStorage.getItem("_LastUpdate");
      if(Tmp === null || Tmp === undefined) 
        return null; 
      else
      {
        var _LastUpdate = JSON.parse(Tmp);
        return _LastUpdate[cache]; 
      }

    } 
    catch (error) {
     return null;
    } 
}
    
public static SetLastUpdateDate(cache : CACHE_KEYS, Data : any = undefined) : void { 
    var Tmp = localStorage.getItem("_LastUpdate");
    if(Tmp === null || Tmp === undefined)
    {
      var _LastUpdate = new Array(Object.keys(CACHE_KEYS).length);
      _LastUpdate[cache] = formatDate(new Date(), "yyyy-MM-dd HH:mm", "en"); 
      localStorage.setItem("_LastUpdate", JSON.stringify(_LastUpdate)); 
    }
    else
    {
      var _LastUpdates =   JSON.parse(Tmp);
      if(Data === null || Data?.length === 0)   
        _LastUpdates[cache] = null;
        else
        _LastUpdates[cache] = formatDate(new Date(), "yyyy-MM-dd HH:mm", "en");

      localStorage.setItem("_LastUpdate", JSON.stringify(_LastUpdates));
    }
 
  }
 
  public static GetCache(callback: (param: any) => any, Cache : CACHE_KEYS) : void {

    try {
 
      switch(Cache)
      {
        case CACHE_KEYS.DOORS :
         localforage.getItem(LoadDataService.CACHE_KEYS_STR.DOORS).then( (Tmp : any) => {
          let Data = JSON.parse(Tmp); 
          callback (Data);  
          LoadDataService.SetLastUpdateDate(Cache, Data);
         });
        break;

        case CACHE_KEYS.ACCESSPOINTS :
          localforage.getItem(LoadDataService.CACHE_KEYS_STR.ACCESSPOINTS).then( (Tmp : any) => {
            let Data = JSON.parse(Tmp); 
            callback (Data);  
            LoadDataService.SetLastUpdateDate(Cache, Data);
           });
        break;

        case CACHE_KEYS.DASHBOARDS :
          localforage.getItem(LoadDataService.CACHE_KEYS_STR.DASHBOARDS).then( (Tmp : any) => {
            let Data = JSON.parse(Tmp); 
            callback (Data);  
            LoadDataService.SetLastUpdateDate(Cache, Data);
           });
        break;

        case CACHE_KEYS.HARDWARES_ILOCK :
          localforage.getItem(LoadDataService.CACHE_KEYS_STR.HARDWARES_ILOCK).then( (Tmp : any) => {
            let Data = JSON.parse(Tmp); 
            callback (Data);  
            LoadDataService.SetLastUpdateDate(Cache, Data);
           });
        break;

        case CACHE_KEYS.HARDWARES_WR:
          localforage.getItem(LoadDataService.CACHE_KEYS_STR.HARDWARES_WR).then( (Tmp : any) => {
            let Data = JSON.parse(Tmp); 
            callback (Data);  
            LoadDataService.SetLastUpdateDate(Cache, Data);
           });
        break;

        case CACHE_KEYS.RFIDSETTINGS :
          localforage.getItem(LoadDataService.CACHE_KEYS_STR.RFIDSETTINGS).then( (Tmp : any) => {
            let Data = JSON.parse(Tmp); 
            callback (Data);  
            LoadDataService.SetLastUpdateDate(Cache, Data);
           });
        break;

        case CACHE_KEYS.SERVICES :
          localforage.getItem(LoadDataService.CACHE_KEYS_STR.SERVICES).then( (Tmp : any) => {
            let Data = JSON.parse(Tmp); 
            callback (Data);  
            LoadDataService.SetLastUpdateDate(Cache, Data);
           });
        break;

        case CACHE_KEYS.SYSTEMSETTINGS :
          localforage.getItem(LoadDataService.CACHE_KEYS_STR.SYSTEMSETTINGS).then( (Tmp : any) => {
            let Data = JSON.parse(Tmp); 
            callback (Data);  
            LoadDataService.SetLastUpdateDate(Cache, Data);
           });
        break;

        case CACHE_KEYS.ACCESS_POINTS :
          localforage.getItem(LoadDataService.CACHE_KEYS_STR.ACCESS_POINTS).then( (Tmp : any) => {
            let Data = JSON.parse(Tmp); 
            callback (Data);  
            LoadDataService.SetLastUpdateDate(Cache, Data);
           });
        break;

        case CACHE_KEYS.ACCESS_POINT_GROUPS :
          localforage.getItem(LoadDataService.CACHE_KEYS_STR.ACCESS_POINT_GROUPS).then( (Tmp : any) => {
            let Data = JSON.parse(Tmp); 
            callback (Data);  
            LoadDataService.SetLastUpdateDate(Cache, Data);
           });
        break;

        case CACHE_KEYS.TIMETABLE :
          localforage.getItem(LoadDataService.CACHE_KEYS_STR.TIMETABLE).then( (Tmp : any) => {
            let Data = JSON.parse(Tmp); 
            callback (Data);  
            LoadDataService.SetLastUpdateDate(Cache, Data);
           });
        break;

        case CACHE_KEYS.WEEKLY_PROGRAM :
          localforage.getItem(LoadDataService.CACHE_KEYS_STR.WEEKLY_PROGRAM).then( (Tmp : any) => {
            let Data = JSON.parse(Tmp); 
            callback (Data);  
            LoadDataService.SetLastUpdateDate(Cache, Data);
           });
        break;

        case CACHE_KEYS.DOOR_PROGRAM :
          localforage.getItem(LoadDataService.CACHE_KEYS_STR.DOOR_PROGRAM).then( (Tmp : any) => {
            let Data = JSON.parse(Tmp); 
            callback (Data);  
            LoadDataService.SetLastUpdateDate(Cache, Data);
           });
        break;


        default :
          callback ([]); 
      }
 
    }
    catch(e){
      callback (null); 
    }

  }
 
  
  public static SaveCache(Data: any, Cache : CACHE_KEYS) : boolean {

    try {
 
      switch(Cache)
      {
        case CACHE_KEYS.DOORS :
         localforage.setItem(LoadDataService.CACHE_KEYS_STR.DOORS, JSON.stringify(Data)); 
        break;

        case CACHE_KEYS.ACCESSPOINTS :
          localforage.setItem(LoadDataService.CACHE_KEYS_STR.ACCESSPOINTS, JSON.stringify(Data)); 
        break;

        case CACHE_KEYS.DASHBOARDS :
          localforage.setItem(LoadDataService.CACHE_KEYS_STR.DASHBOARDS, JSON.stringify(Data)); 
        break;

        case CACHE_KEYS.HARDWARES_ILOCK :
          localforage.setItem(LoadDataService.CACHE_KEYS_STR.HARDWARES_ILOCK, JSON.stringify(Data)); 
        break;

        case CACHE_KEYS.HARDWARES_WR :
          localforage.setItem(LoadDataService.CACHE_KEYS_STR.HARDWARES_WR, JSON.stringify(Data)); 
        break;

        case CACHE_KEYS.RFIDSETTINGS :
          localforage.setItem(LoadDataService.CACHE_KEYS_STR.RFIDSETTINGS, JSON.stringify(Data)); 
        break;

        case CACHE_KEYS.SERVICES :
          localforage.setItem(LoadDataService.CACHE_KEYS_STR.SERVICES, JSON.stringify(Data)); 
          console.log("Serv: "+ LoadDataService.CACHE_KEYS_STR.SERVICES);
        break;

        case CACHE_KEYS.SYSTEMSETTINGS :
          localforage.setItem(LoadDataService.CACHE_KEYS_STR.SYSTEMSETTINGS, JSON.stringify(Data)); 
        break;

        case CACHE_KEYS.ACCESS_POINTS :
          localforage.setItem(LoadDataService.CACHE_KEYS_STR.ACCESS_POINTS, JSON.stringify(Data)); 
        break;

        case CACHE_KEYS.ACCESS_POINT_GROUPS :
          localforage.setItem(LoadDataService.CACHE_KEYS_STR.ACCESS_POINT_GROUPS, JSON.stringify(Data)); 
        break;

        case CACHE_KEYS.TIMETABLE :
          localforage.setItem(LoadDataService.CACHE_KEYS_STR.TIMETABLE, JSON.stringify(Data)); 
        break;
        
        case CACHE_KEYS.WEEKLY_PROGRAM :
          localforage.setItem(LoadDataService.CACHE_KEYS_STR.WEEKLY_PROGRAM, JSON.stringify(Data)); 
        break;

        case CACHE_KEYS.DOOR_PROGRAM :
          localforage.setItem(LoadDataService.CACHE_KEYS_STR.DOOR_PROGRAM, JSON.stringify(Data)); 
        break;
        
        default :
          return false; 
      }

      LoadDataService.SetLastUpdateDate(Cache); 
      return true; 

    }
    catch(e){
      return false; 
    }

  } 

  /* TODO: update this function, when an exception happen, get the available cache */

  public static GetCachedOrApiData(callback: (param: any) => any, Data: any, Cache: CACHE_KEYS): any
  {
    /* Successful response but unde data, or the data is not an array */
    if(Data === undefined || Data === null || !Array.isArray(Data)) {
      if(!Array.isArray(Data) && Data?._Message?.length > 0 && Data?._Error_Code > 0)
         LoadDataService.GetCache(callback, Cache);  
      else
         callback(null);
      
      return true; 
    }
    
    /* Save cache only if data exist as an array and non array except non array object error */
     var Tmp =  LoadDataService.SaveCache(Data, Cache); 
     callback(Data);

     return Tmp;
  }

  
}

export enum CACHE_KEYS {
  DOORS,
  SERVICES,
  DASHBOARDS,
  HARDWARES_ILOCK,
  ACCESSPOINTS,
  SYSTEMSETTINGS,
  RFIDSETTINGS,
  HARDWARES_WR,
  ACCESS_POINTS,
  ACCESS_POINT_GROUPS,
  TIMETABLE,
  WEEKLY_PROGRAM,
  DOOR_PROGRAM
}
